<app-management-sidemenu>
  <h1 class="heading">{{ "ActionLogs" | localize }}</h1>
  <div class="action-logs-container custom-admin-label-class">
    <div class="action-logs-header">
      <div class="action-logs-process"></div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <div class="table-responsive">
        <mat-table [dataSource]="dataSource">
          <!-- platform Column -->
          <ng-container matColumnDef="platform">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label style="font-weight: 600; color: #777777">{{
                  "platform" | localize
                }}</mat-label>
                <input
                  [(ngModel)]="inputValues['platform']"
                  matInput
                  (input)="onInputChange($event, false, 'platform')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.platform }}"
              matTooltipClass="custom-tool-tip"
              matTooltipPosition="below"
            >
              {{ element.platform }}
            </mat-cell>
          </ng-container>
          <!-- source Column -->
          <ng-container matColumnDef="source">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label style="font-weight: 600; color: #777777">{{
                  "source" | localize
                }}</mat-label>
                <input
                  [(ngModel)]="inputValues['source']"
                  matInput
                  (input)="onInputChange($event, false, 'source')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.source }}"
              matTooltipClass="custom-tool-tip"
              matTooltipPosition="below"
            >
              {{ element.source }}
            </mat-cell>
          </ng-container>
          <!-- operations Column -->
          <ng-container matColumnDef="operations">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label style="font-weight: 600; color: #777777">{{
                  "operations" | localize
                }}</mat-label>
                <input
                  [(ngModel)]="inputValues['operations']"
                  matInput
                  (input)="onInputChange($event, false, 'operations')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.operations }}"
              matTooltipClass="custom-tool-tip"
              matTooltipPosition="below"
            >
              {{ element.operations }}
            </mat-cell>
          </ng-container>
          <!-- foreignId Column -->
          <ng-container matColumnDef="foreignId">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label style="font-weight: 600; color: #777777">{{
                  "foreignId" | localize
                }}</mat-label>
                <input
                  [(ngModel)]="inputValues['foreignId']"
                  matInput
                  (input)="onInputChange($event, false, 'foreignId')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.foreignId }}"
              matTooltipClass="custom-tool-tip"
              matTooltipPosition="below"
            >
              {{ element.foreignId }}
            </mat-cell>
          </ng-container>
          <!-- userId Column -->
          <ng-container matColumnDef="userId">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label style="font-weight: 600; color: #777777">{{
                  "userId" | localize
                }}</mat-label>
                <input
                  [(ngModel)]="inputValues['userId']"
                  matInput
                  (input)="onInputChange($event, false, 'userId')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.userId }}"
              matTooltipClass="custom-tool-tip"
              matTooltipPosition="below"
            >
              {{ element.userId }}
            </mat-cell>
          </ng-container>
          <!-- duration Column -->
          <ng-container matColumnDef="duration">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "duration" | localize }}</mat-label>
                <input
                  [(ngModel)]="inputValues['duration']"
                  matInput
                  (input)="onInputChange($event, false, 'duration')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.duration }}"
              matTooltipClass="custom-tool-tip"
              matTooltipPosition="below"
            >
              {{ element.duration }}
            </mat-cell>
          </ng-container>
          <!-- createdDate Column -->
          <ng-container matColumnDef="createdDate">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "createdDate" | localize }}</mat-label>
                <input
                  [(ngModel)]="inputValues['createdDate']"
                  matInput
                  (input)="onInputChange($event, false, 'createdDate')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.createdDate }}"
              matTooltipClass="custom-tool-tip"
              matTooltipPosition="below"
            >
              {{ element.createdDate }}
            </mat-cell>
          </ng-container>
          <!-- device Column -->
          <ng-container matColumnDef="device">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "device" | localize }}</mat-label>
                <input
                  [(ngModel)]="inputValues['device']"
                  matInput
                  (input)="onInputChange($event, false, 'device')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.device }}"
              matTooltipClass="custom-tool-tip"
              matTooltipPosition="below"
            >
              {{ element.device }}
            </mat-cell>
          </ng-container>
          <!-- osVersion Column -->
          <ng-container matColumnDef="osVersion">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "osVersion" | localize }}</mat-label>
                <input
                  [(ngModel)]="inputValues['osVersion']"
                  matInput
                  (input)="onInputChange($event, false, 'osVersion')"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.osVersion }}"
              matTooltipClass="custom-tool-tip"
              matTooltipPosition="below"
            >
              {{ element.osVersion }}
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>

      <!--Paginator-->
      <div class="custom-paginator">
        <span *ngIf="userSearchLength > 0; else noRecords">
          {{ userSearchLength }} {{ 'entries' | localize }} {{ currentPage * pageSize + 1 }} -
          {{ Math.min(userSearchLength, (currentPage + 1) * pageSize) }}
          {{ 'betweenDisplayed' | localize }}
        </span>
        <ng-template #noRecords> {{ 'noRecordFound' | localize }} </ng-template>

        <!-- Paginator Buttons -->
        <button (click)="onPageChange(0)" [disabled]="currentPage === 0">
          &laquo;
        </button>
        <button
          (click)="onPageChange(currentPage - 1)"
          [disabled]="currentPage === 0"
        >
          &lt;
        </button>
        <ng-container *ngFor="let page of visiblePageNumbers">
          <button
            [class.active]="page - 1 === currentPage"
            (click)="onPageChange(page - 1)"
          >
            {{ page }}
          </button>
        </ng-container>
        <button
          (click)="onPageChange(currentPage + 1)"
          [disabled]="currentPage >= totalPages - 1"
        >
          &gt;
        </button>
        <button
          (click)="onPageChange(totalPages - 1)"
          [disabled]="currentPage >= totalPages - 1"
        >
          &raquo;
        </button>
        <!--PageSize selection-->
        <select [(ngModel)]="pageSize" (change)="updatePageSize($event)">
          <option *ngFor="let option of [5, 10]" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
</app-management-sidemenu>
